import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

interface INoDataProps {
    className?: string;
}

const NoData = ({ className }: INoDataProps) => {
    const { t } = useTranslation();

    return (
        <div data-testid="noData" className={className}>
            {t('organizationDetailsView_noData_title')}
        </div>
    );
};

const Memoized = memo(NoData);
const Styled = styled(Memoized)`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export default Styled;
